import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Link,
  makeStyles
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import moment from 'moment-timezone';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: theme.shadows[2],
  },
  successBorder: {
    borderLeft: '5px solid green',
  },
  failBorder: {
    borderLeft: '5px solid red',
  },
  timestamp: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  itemTime: {
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
    borderRadius: 5,
    border: '1px solid',
    paddingLeft: 2,
    paddingRight: 2,
    position: 'relative',
    '&::after': {
      content: '"›"', // Chevron
      position: 'absolute',
      right: -10,
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '1rem',
      color: theme.palette.primary.main,
    },
  },
  description: {
    fontSize: '0.95rem',
  },
  statusText: {
    fontWeight: 600,
  },
}));

const EventList = ({ data = [], jobType, jobStatus }) => {
  const classes = useStyles();

  const renderDescription = (desc) => {
    if (typeof desc === 'string') {
      const lower = desc.toLowerCase();
      if (lower.includes('cancelled at')) return 'Cancelado';
      if (lower.includes('started at') || lower.includes('arrived at') || lower.includes('modified by')) return '';
      if (lower.includes('successful at')) return 'Finalizou';
      return desc;
    }
    if (typeof desc === 'object' && desc.fleet_data) return desc.fleet_data;
    return '-';
  };

  const getStatusText = (data = []) => {
    const status = data.find(item => String(item.description.label).toLowerCase().includes('status'));
    return status?.description?.input || '';
  };

  const isSuccess = (data = []) => {
    const status = data.find(item => String(item.description.label).toLowerCase().includes('status'));
    
    return String(status?.description?.fleet_data || '').toLowerCase().includes('sucesso')
     || String(status?.description?.fleet_data || '').toLowerCase().includes('coletado')
     || String(status?.description?.fleet_data || '').toLowerCase().includes('entregue')
  };

  const statusList = {
    "STARTED": "Iniciada",
    "ARRIVED": "Chegou ao local",
    "UPDATED": "",
  };

  const success = isSuccess(data);
  const borderClass = success ? classes.successBorder : classes.failBorder;
  const statusColor = success ? 'green' : 'red';

  // Remover eventos de status da lista
  const filteredData = data.filter(item => {
    if (typeof item.description === 'object') {
      return !String(item.description.label).toLowerCase().includes('status');
    }
    return true;
  });

  return (
    filteredData && filteredData.length > 0 ?
    <Accordion className={`${classes.root} ${borderClass}`}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1" className={classes.itemTime}>
            {moment(data[0]?.creation_datetime).format('DD/MM/YYYY')}
          </Typography>
          <Typography className={classes.statusText} style={{ color: statusColor }}>
            {getStatusText(data)}
          </Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container direction="column" spacing={1}>
          {filteredData.map((item, index) => (
            item.label &&
            <Grid item key={index}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <Typography className={classes.itemTime}>
                    {moment(item.creation_datetime).format('HH:mm')}
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography className={classes.description}>
                    {String(renderDescription(item.description)).startsWith('http') ? (
                      <Link href={renderDescription(item.description)} target="_blank" >
                        Clique aqui para ver a evidência
                      </Link>
                    ) : (
                      `${item?.description?.label ? `${item?.description?.label}:` : ''} ${statusList[item.label] || ''} ${renderDescription(item.description)}`
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
    : null
    // <Card>
    //   <CardContent style={{backgroundColor:'aliceblue'}}>
    //     <Typography variant='h5' style={{color:'blueviolet', fontWeight:'bold', textAlign:'center'}}>
    //       Aguardando atualização de status
    //     </Typography>
    //   </CardContent>
    // </Card>
  );
};

export default EventList;
